import React from 'react';
import { Loader2, Database } from 'lucide-react';
import { useAuth } from '@/lib/auth';
import { EmptyState } from './Loaders';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function CompanyGate({ children, message }) {
  const { effectiveCompanyId, isSuperAdmin } = useAuth();
  if (!effectiveCompanyId) {
    return (
      <div className="max-w-md mx-auto mt-8" data-testid="company-gate-prompt">
        <EmptyState
          icon={Database}
          title={isSuperAdmin ? 'Select a company first' : 'No company assigned'}
          description={isSuperAdmin
            ? (message || 'Use the Company Switcher at the top to choose which company’s data to view.')
            : 'Please contact your Super Admin to assign you to a company.'}
          action={isSuperAdmin ? (
            <Button asChild variant="default" className="luxury-button">
              <Link to="/admin/companies" data-testid="company-gate-companies-link">Manage Companies</Link>
            </Button>
          ) : null}
        />
      </div>
    );
  }
  return children;
}
